import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const QuestionService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 试题分页
     */
    questionPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'question/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得试题
    */
    questionGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'question/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得试题详情
    */
    questionGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'question/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 试题保存
     */
    questionSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'question/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试题更新
     */
    questionUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'question/update/' + params.id, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 试题删除
     */
    questionRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'question/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    questionChangeIsState({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + `question/changeIsState/${params.id}`, params.isDisabled).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导出
    exportData({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.exportData(constants.EXAM + 'export/exportData', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getExportProcessStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.exportData(constants.EXAM + 'export/getProcessStatus', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入
    importData({ commit }, formData) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'import/data', formData).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 导入数据实时进度
    getImportProcessStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'import/getProcessStatus', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 随机试题生成
     */
    generateQuestion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'question/generateQuestion', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 上一题
     */
    beforeQuestion({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'question/before', { id: id }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
       * 下一题
       */
    afterQuestion({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'question/after', { id: id }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default QuestionService
